import { IStyleConfig, mergeStyles } from '@cian/utils';
import * as React from 'react';

import { PreloaderIcon } from '../../../common/icons';

const styles = require('./preloader.css');

interface IPreloaderProps {
  size?: number;
  containerStyle?: IStyleConfig;
}

export const Preloader = (props: IPreloaderProps) => {
  const { size, containerStyle } = props;

  const style = [containerStyle, styles['preloader'], size && { height: size, width: size }];

  return (
    <div {...mergeStyles(style)}>
      <PreloaderIcon />
    </div>
  );
};
